export function sanitizeEmail(email: string | undefined): string {
  // TODO: we shouldn't have to handle undefined as an input. In reality it
  // should never be passed in and the typechecker is happy if we don't handle
  // it. However a number of tests arrange that situation through (what I think
  // are) incomplete mocks. We should remove handling of this case and fix
  // broken tests that sneak undefined through to here.
  return email?.toLowerCase() || ''
}
